export const EMAIL_MAX = 254;

export default function emailInputClean(value: string): string {
    return value.replace(/[\s\p{Cc}\p{Cf}<>()[\]\\,;:"]/gu, '').slice(0, EMAIL_MAX);
}
